<template>
  <div>
    <HeaderNoAccess></HeaderNoAccess>
    <div class="d-flex justify-center login-recover-window" style="margin: 10vh auto;">
      <v-card class="elevation-12" style=" width: 500px;">
        <v-card-title class="d-flex justify-center align-center" style="flex-direction: column;">
          <img v-if="logoImage" :src="`${backendurl}/shared/logo-images/${this.logoImage}`" style="max-height: 100px;">
          <span style="font-size: larger;">Register SSO account</span>
        </v-card-title>
        <v-card-text>
          <div class="pa-4">
            <div class="d-flex" style="flex-direction: column; justify-content: space-between; gap: 12px;">
              <v-btn @click="registerAccount()" block class="login-button">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <img src="../../../assets/Microsoft_icon.svg.png" style="max-height: 24px;" />
                  Microsoft
                </div>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/plugins/backendAPI'
import { mapGetters } from 'vuex';
import HeaderNoAccess from '../../../components/HeaderNoAccess.vue';
import { logout } from '../../../helpers/logoutHandler';

export default {
  components: {
    HeaderNoAccess
  },
  data() {
    return {
      logoImage: null,
      // eslint-disable-next-line no-undef
      backendurl: process.env.VUE_APP_APIURL,
    }
  },
  async created() {
  },
  async mounted() {
    await HTTP.get(`/organization/get/logo?organization-id=${this.$route.query["organization-id"]}`)
      .then((response) => {
        this.logoImage = response.data
      })
      .catch()
    this.msalInstance.clearCache()

    if (this.$route.query["auto-accept"]) {
      await this.registerAccount()
    }
  },
  computed: {
    ...mapGetters(["msalInstance"])
  },
  methods: {
    triggerLoginByEnter(e) {
      if (e.keyCode === 13) {
        this.registerAccount()
      }
    },
    async registerAccount() {
      this.$store.dispatch("setLoading", true)
      delete HTTP.defaults.headers.common['Authorization']
      await HTTP.get(`/auth/get/method`)
        .then(async (response) => {
          await this.$store.dispatch("saveUserSSOAuthMethod", response.data.ssoAuthMethod)
        })
        .catch(async (e) => {
          if (e.response.status !== 500) {
            this.$router.push({ name: "AdminSignIn", query: { "error": `Account registration failed: Missing auth-method query in url.` } })
            return
          }
          this.$router.push({ name: "AdminSignIn", query: { "error": `Account registration failed: Unknown server error.` } })
        })
      if (["SAML", "OIDC"].includes(this.$store.getters.userSSOAuthMethod)) {
        try {
          if (this.$store.getters.userSSOAuthMethod === "SAML") {
            window.location.href = `${process.env.VUE_APP_APIURL}/auth/register-account/saml?entra-tenant-id=${this.$route.query["entra-tenant-id"]}&organization-id=${this.$route.query["organization-id"]}`
          }
          if (this.$store.getters.userSSOAuthMethod === "OIDC") {
            const loginRequest = {
              scopes: ["User.Read"]
            };
            const msalResponse = await this.msalInstance.loginPopup(loginRequest);
            if (msalResponse.idTokenClaims.groups === null) {
              throw new Error("Account registration failed: Your account has not yet been activated.")
            }
            await HTTP.post(`/auth/register-account/oidc?entra-tenant-id=${this.$route.query["entra-tenant-id"]}&organization-id=${this.$route.query["organization-id"]}`, msalResponse.idTokenClaims.groups)
              .then(async (response) => {
                if (response.data.redirectTo) {
                  await this.$router.push({ name: "AuthCallback", query: { "auth-method": "OIDC", "redirect-to": response.data.redirectTo, "entra-tenant-id": this.$route.query["entra-tenant-id"], "organization-id": this.$route.query["organization-id"], "email": msalResponse.idTokenClaims.preferred_username } })
                } else {
                  await this.$router.push({ name: "AuthCallback", query: { "auth-method": "OIDC", "token": HTTP.defaults.headers.common['Authorization'].substring("Bearer ".length) } })
                }
              })
              .catch(async (e) => {
                if (e.response.status === 400) {
                  this.$router.push({ name: "AdminSignIn", query: { "error": `Account registration failed: ${e.response.data}` } })
                }
                throw new Error(`Account registration failed: Could not register account.`)
              })
          }
        } catch (error) {
          this.msalInstance.clearCache()
          this.$store.dispatch('showError', error)
          this.$store.dispatch('saveUserSSOAuthMethod', null);
          this.$store.dispatch('deleteAuthorization')
          this.$store.dispatch("setLoading", false)
        }
      }
      else {
        await logout()
      }
    },
  }
}

</script>

<style scoped lang="css">
.additional-login-info {
  margin-bottom: 25px;
  text-align: center;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: bolder;
  color: lightcoral;
}
</style>
